import { sendClarityCustomEvent } from '@/shared/analytics/clarityCustomEvent'

export type CbamReportingClarityEvent =
  | 'reporting:good:inspected'
  | 'reporting:good:liability-explanation:opened'
  | 'reporting:filter:specific-grr:selected'

export function trackCbamReportingSignal(event: CbamReportingClarityEvent): void {
  sendClarityCustomEvent(event)
}
